






































































import Vue from 'vue';
import dayjs from 'dayjs';
import { Campaign } from '@/models';

export default Vue.extend({
  props: {
    campaign: Object,
  },
  data() {
    return {
      menu: false,
      menu2: false,
      scheduled: dayjs(this.campaign.scheduledTo.iso).isAfter(dayjs()),
      rateLimit: !!this.campaign.rateLimit,
      rules: {
        required: [(v: any) => v !== undefined && v !== '' || 'Campo obrigatório'],
      },
      volumeOptions: [{
        label: '100 mensagens', value: 100,
      }, {
        label: '200 mensagens', value: 200,
      }, {
        label: '300 mensagens', value: 300,
      }],
      unitOptions: [{
        label: 'Hora', value: 'HOUR',
      }, {
        label: 'Dia', value: 'DAY',
      }],
    };
  },
  watch: {
    scheduled(val) {
      if (val) {
        this.$emit('update', {
          scheduledTo: {
            __type: 'Date',
            iso: dayjs().add(5, 'minute').toISOString(),
          },
        });
      } else {
        this.$emit('update', { scheduledTo: {
          __type: 'Date',
          iso: dayjs().toISOString(),
        } });
      }
    },
    rateLimit(val) {
      if (val) {
        this.$emit('update', { rateLimit: {} });
      } else {
        this.$emit('update', { rateLimit: null });
      }
    },
  },
  methods: {
    onInputClick(id: string) {
      this.eventFire(document.getElementById(id), 'click');
    },
    eventFire(el: any, etype: any) {
      if (el.fireEvent) {
        el.fireEvent('on' + etype);
      } else {
        const evObj = document.createEvent('Events');
        evObj.initEvent(etype, true, false);
        el.dispatchEvent(evObj);
      }
    },
    formatCheckDate() {
      return dayjs(new Date()).format('DD MMM YYYY HH:mm') || '';
    },
    formattedDate(date: Date) {
      return date && dayjs(date).format('DD MMM YYYY HH:mm') || '';
    },
  },
});
